// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nT05ciqyPvHR_jr46Rfn {\n  display: grid;\n  justify-items: center;\n}\n.zRN9ZhtllTiNPts3Lv2d {\n  height: 50px;\n}\n.RdKlQ8Q8VgV5_1ZyJVRN {\n  width: 335px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/map/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":[".container {\n  display: grid;\n  justify-items: center;\n}\n.marker-img {\n  height: 50px;\n}\n.instructions {\n  width: 335px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "nT05ciqyPvHR_jr46Rfn",
	"marker-img": "zRN9ZhtllTiNPts3Lv2d",
	"instructions": "RdKlQ8Q8VgV5_1ZyJVRN"
};
export default ___CSS_LOADER_EXPORT___;
